import React, { Fragment, useEffect, useState } from "react";
import { useRoutes } from "react-router-dom";
import { AllPages } from "./app/routes/routes";

const ALLOWED_IP = "103.93.199.151";

const MaintenancePage = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      background: "#f4f6f9",
      fontFamily: "sans-serif",
      textAlign: "center",
      padding: "2rem",
    }}
  >
    <svg
      width="80"
      height="80"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#e67e22"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ marginBottom: "1.5rem" }}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    <h1 style={{ fontSize: "2rem", color: "#2c3e50", margin: "0 0 0.75rem" }}>
      Under Maintenance
    </h1>
    <p style={{ fontSize: "1.1rem", color: "#7f8c8d", maxWidth: "480px", lineHeight: 1.6 }}>
      We are currently performing scheduled maintenance. We will be back shortly.
      Thank you for your patience.
    </p>
    <p style={{ marginTop: "2rem", fontSize: "0.85rem", color: "#bdc3c7" }}>
      NRB Portal
    </p>
  </div>
);

const App = () => {
  const all_pages = useRoutes(AllPages());
  const [allowed, setAllowed] = useState(null); // null = loading

//   useEffect(() => {
//     const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
//     fetch(`${baseUrl}/client-ip`)
//       .then((r) => r.json())
//       .then((data) => {
//         setAllowed(data.ip === ALLOWED_IP);
//       })
//       .catch(() => {
//         // If IP check fails, deny access to be safe
//         setAllowed(false);
//       });
//   }, []);

//   if (allowed === null) return null; // loading — blank screen briefly
//   if (!allowed) return <MaintenancePage />;

  return <>{all_pages}</>;
};

export default App;
